<app-dashboard-container
	class="dashboard-cijfers"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, $event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijfers"
		[permanentFilterExpressions]="permanentFilterExpressions"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			@if (variant() === DashboardVariant.ACTUEEL) {
				<app-multi-select-dropdown
					label="Kolommen"
					[allOptions]="columnMultiSelectOptions"
					[value]="visibleColumns"
					(valueChange)="qp.dispatch('col', $event)"
					placeholder="Kolommen"
				>
				</app-multi-select-dropdown>
			}
			<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov']"></app-legenda>
		</app-dashboard-header>
		@switch (variant()) {
			@case (DashboardVariant.ACTUEEL) {
				<app-barchart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groeperingService.huidigeGroeperingen()"
					[config]="this"
				>
				</app-barchart-table>
			}
			@case (DashboardVariant.HISTORIE) {
				<app-vbarchart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="historieGroups()"
					[subgroups]="historieSubgroups()"
					[batchLevels]="isHistorieBatchVariant() ? 1 : 0"
					[config]="this"
					[schooljaarPath]="['cf_nm_schooljaar']"
					[partitionMeasure]="partitionMeasure"
				>
				</app-vbarchart-table>
			}
		}
	</section>
</app-dashboard-container>
